import { useParams } from "react-router-dom";
import { FunnelDashboard } from "@/components/admin/FunnelDashboard";

export default function AdminFunnel() {
  const { campaign = "" } = useParams();
  const title = campaign
    ? campaign.replace(/[_-]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) + " Funnel"
    : "Funnel";
  return <FunnelDashboard campaign={campaign} title={title} />;
}